var currentScroll =0;
  
$(function(){
  

  $(document).on('keyup', function(e) {
   
    if (e.key == "Escape") {
      if($('.toggle-menu-desktop').hasClass('is-open')) { toggleMenu();	}
      
      
    }
  });
  
    // Sticky menu 
    $(window).on("scroll", function() {
      if($(window).scrollTop() > 50) {

        //if($('.toggle-menu-desktop').hasClass('is-open') && $(window).scrollTop() > currentScroll+800) toggleMenu();
        $(".site-header").addClass("active");
      } else {
        //remove the background property so it comes transparent again (defined in your css)
        if(!$('.toggle-menu-desktop').hasClass('is-open')) $(".site-header").removeClass("active");
      }
    });


    // Trigger to open / close menu
    $('.toggle-menu-desktop, .nav-overlay').on('click', toggleMenu);  //$('.site-nav li:first-child .dropdown').css('display', 'flex');



    // Mega Menu Scripts
    var lastNavEntered;
  
    $('.site-nav li').on('mouseleave', function() {
          $('.site-nav li').each(function() {
           // if(!$(this).hasClass('dropdown-hover')) {
              $(this).find('.dropdown').css('display', 'none');
           // }
          });
    });

    $('.site-nav li a.menu_a').on('mouseenter', function() {
      lastNavEntered = $(this).parent();
    });

    $('.site-nav').on('mouseleave', function() {
          $(lastNavEntered).addClass('dropdown-hover');
          $(lastNavEntered).find('.dropdown').css('display', 'flex');
    });	
  
  
  
    // Menu Icons - hover effect
    $('.site-nav .dropdown li a').hover(
      function() { 
        $(this).find('img.nicon').attr('src', $(this).find('img.nicon').data('hover'));
      },

      function() { 
        $(this).find('img.nicon').attr('src',  $(this).find('img.nicon').data('out'));

      },
    );
      
      
    // Search Toggle on top  
    
    $('.site-header .search').on('click', function() {
    	$('.search-wrapper').slideToggle();
    	$('.search-wrapper').find('input').focus();
  	});
  
  	// Search Close button
    $('.search-wrapper').find('button').on('click', function() {
          $('.search-wrapper').slideUp();
      $('.search-wrapper').find('input').blue();
    });
  
	
  
	$(window).scroll(function(){
            if($(this).scrollTop()>500) {
                $('.backtotop').show();
            } else {
                $('.backtotop').hide();

            }
            
        });
  
  
  	if(page_template == "index") {
        $('.page_loader').hide();      
    }
  
  
  
});

$(window).on("load", function() {
  setTimeout(
    function() {  
      $('.page_loader').slideUp(400);                   
      if(page_template == "index") {
        //$('.page_loader').hide();
        //const flkty = Flickity.data('.product_highlights_slider');
       //	$('.slideshow-1481011869014 .slideshow-carousel').flickity( 'select', 0, false, true); 
        

        
      }
    }, 1000);
});

function toggleMenu(){
    if($('.toggle-menu-desktop').hasClass('is-open')) {	
        if($(window).scrollTop() < 50) $('.site-header').removeClass('active');
        $('.site-nav li').removeClass('dropdown-hover');
        $('.site-nav li').each(function() {
          // if(!$(this).hasClass('dropdown-hover')) {
          $(this).find('.dropdown').css('display', 'none');
          // }
        });


    } else  {
        $('.site-header').addClass('active');
        $('.site-nav li:first-child').addClass('dropdown-hover');
    }

    $('.toggle-menu-desktop').toggleClass('is-open');
    $('.nav-bar').toggle('slide');
    $('.nav-overlay').toggle();
    
}
  

function scrollToAnchor(aid,offset=0){
    var aTag = $("a[name='"+ aid +"']");
    $('html,body').animate({scrollTop: aTag.offset().top-offset},'slow');
}